export default __webpack_public_path__ + "static/radialPlusApp-39277d6a461e50b719afda18a3667f0a.png";